(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c_beneficios"] && !Shopify.designMode) return;
  try {
    
(function () {
  function racbuInitBenefits(root) {
    if (root.dataset.racbuInit === 'true') return;
    root.dataset.racbuInit = 'true';

    var list = root.querySelector('[data-racbu-list]');
    var items = root.querySelectorAll('[data-racbu-reveal]');

    if (!('IntersectionObserver' in window)) {
      root.classList.add('racbu-no-js');
      if (list) list.classList.add('is-visible');
      return;
    }

    if (list) {
      var listObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            listObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
      listObserver.observe(list);
    }

    var itemObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          itemObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el) {
      itemObserver.observe(el);
    });
  }

  function racbuScanBenefits() {
    document.querySelectorAll('.racbu-benefits').forEach(racbuInitBenefits);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', racbuScanBenefits);
  } else {
    racbuScanBenefits();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('.racbu-benefits');
    if (root) racbuInitBenefits(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c_compra"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function addDays(date, days, skipWeekends) {
    var d = new Date(date.getTime());
    var added = 0;
    if (days <= 0) return d;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (skipWeekends) {
        var day = d.getDay();
        if (day === 0 || day === 6) continue;
      }
      added++;
    }
    return d;
  }

  function formatDate(date, locale) {
    try {
      var f = new Intl.DateTimeFormat(locale || 'es-MX', { weekday: 'short', day: 'numeric', month: 'short' }).format(date);
      return f.charAt(0).toUpperCase() + f.slice(1);
    } catch (e) {
      return date.toLocaleDateString();
    }
  }

  function computeEstimate(root) {
    var cutoffHour = parseInt(root.dataset.cutoffHour, 10) || 13;
    var minDays = parseInt(root.dataset.minDays, 10) || 3;
    var maxDays = parseInt(root.dataset.maxDays, 10) || 7;
    var skipWeekends = root.dataset.skipWeekends === 'true';
    var locale = root.dataset.locale || 'es-MX';

    var now = new Date();
    var cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);

    var pastCutoff = now.getTime() >= cutoff.getTime();
    var dispatch = new Date(now);
    if (pastCutoff) dispatch.setDate(dispatch.getDate() + 1);

    var minDate = addDays(dispatch, minDays, skipWeekends);
    var maxDate = addDays(dispatch, maxDays, skipWeekends);

    return {
      pastCutoff: pastCutoff,
      cutoff: cutoff,
      now: now,
      minDateText: formatDate(minDate, locale),
      maxDateText: formatDate(maxDate, locale)
    };
  }

  function setDeliveryLine(element, title, text) {
    element.textContent = '';

    var titleElement = document.createElement('strong');
    var textElement = document.createElement('span');

    titleElement.textContent = title;
    textElement.textContent = text;

    element.appendChild(titleElement);
    element.appendChild(textElement);
  }

  function renderDelivery(root) {
    var cutoffEl = root.querySelector('[data-racbu-cutoff-text]');
    var datesEl = root.querySelector('[data-racbu-dates-text]');
    if (!cutoffEl || !datesEl) return;

    var cutoffHour = parseInt(root.dataset.cutoffHour, 10) || 13;
    var est = computeEstimate(root);

    if (!est.pastCutoff) {
      var diff = est.cutoff.getTime() - est.now.getTime();
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);

      setDeliveryLine(
        cutoffEl,
        'Tu pedido sale hoy',
        'Compra en las próximas ' + h + ' h ' + pad(m) + ' min, antes del corte de las ' + pad(cutoffHour) + ':00.'
      );
    } else {
      setDeliveryLine(
        cutoffEl,
        'El corte de hoy ya pasó',
        'Los pedidos realizados después de las ' + pad(cutoffHour) + ':00 salen el siguiente día hábil.'
      );
    }

    setDeliveryLine(
      datesEl,
      'Entrega estimada',
      est.minDateText + ' – ' + est.maxDateText
    );
  }

  function initCountdown(root) {
    renderDelivery(root);
    setInterval(function () { renderDelivery(root); }, 30000);
  }

  function initQty(root) {
    var wrap = root.querySelector('[data-racbu-qty]');
    if (!wrap) return;

    var input = wrap.querySelector('[data-racbu-qty-input]');
    var valueElement = wrap.querySelector('[data-racbu-qty-value]');
    var minus = wrap.querySelector('[data-racbu-qty-minus]');
    var plus = wrap.querySelector('[data-racbu-qty-plus]');

    if (!input || !valueElement || !minus || !plus) return;

    function setQuantity(value) {
      var quantity = Math.max(1, parseInt(value, 10) || 1);
      input.value = quantity;
      valueElement.textContent = quantity;
      valueElement.setAttribute('aria-label', 'Cantidad seleccionada: ' + quantity);
    }

    minus.addEventListener('click', function () {
      setQuantity((parseInt(input.value, 10) || 1) - 1);
    });

    plus.addEventListener('click', function () {
      setQuantity((parseInt(input.value, 10) || 1) + 1);
    });

    setQuantity(input.value);
  }

  function setState(root, state) {
    root.classList.remove('is-loading', 'is-success');
    if (state) root.classList.add(state);
  }

  function initForm(root) {
    var form = root.querySelector('[data-racbu-form]');
    if (!form) return;
    var status = root.querySelector('[data-racbu-status]');
    var submitBtn = root.querySelector('[data-racbu-submit]');
    var addUrl = root.dataset.cartAddUrl || '/cart/add';
    var redirectToCart = root.dataset.redirectCart === 'true';
    var cartUrl = root.dataset.cartUrl || '/cart';

    document.addEventListener('variant:change', function (evt) {
      var input = root.querySelector('[data-racbu-variant-id]');
      if (input && evt.detail && evt.detail.variant && evt.detail.variant.id) {
        input.value = evt.detail.variant.id;
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (root.classList.contains('is-loading')) return;

      var formData = new FormData(form);
      var payload = {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10) || 1
      };

      setState(root, 'is-loading');
      status.textContent = '';
      status.classList.remove('is-error');

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, data: data }; });
        })
        .then(function (result) {
          if (!result.ok) {
            var message = (result.data && result.data.description) || 'No se pudo agregar el producto. Intenta de nuevo.';
            setState(root, null);
            status.textContent = message;
            status.classList.add('is-error');
            return;
          }

          setState(root, 'is-success');
          status.textContent = 'Agregado a tu carrito';

          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: result.data }));
          document.querySelectorAll('[data-cart-count]').forEach(function (el) {
            var current = parseInt(el.textContent, 10) || 0;
            el.textContent = current + payload.quantity;
          });

          setTimeout(function () {
            if (redirectToCart) {
              window.location.href = cartUrl;
            } else {
              setState(root, null);
            }
          }, 900);
        })
        .catch(function () {
          setState(root, null);
          status.textContent = 'No se pudo agregar el producto. Intenta de nuevo.';
          status.classList.add('is-error');
        });
    });
  }

  function initReveal(root) {
    var items = root.querySelectorAll('[data-racbu-reveal]');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });

    items.forEach(function (el) { observer.observe(el); });
  }

  function racbuInitBuybox(root) {
    if (root.dataset.racbuInit === 'true') return;
    root.dataset.racbuInit = 'true';

    initQty(root);
    initForm(root);
    initReveal(root);
    initCountdown(root);
  }

  function racbuScan() {
    document.querySelectorAll('[data-racbu-buybox]').forEach(racbuInitBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', racbuScan);
  } else {
    racbuScan();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-racbu-buybox]');
    if (root) racbuInitBuybox(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpt_botonstiky"] && !Shopify.designMode) return;
  try {
    
(function () {
  var FALLBACK_SELECTORS = [
    '.racbu-buybox__bundle',
    '.racbu-buybox__badge-wrap',
    '[data-racbu-offer-selector]',
    '[data-racbu-offer]',
    '.racbu-buybox__qty',
    '[data-racbu-qty]',
    '.racbu-buybox__controls',
    '.racbu-buybox'
  ];

  function safeQuery(selector) {
    if (!selector) return null;

    try {
      return document.querySelector(selector);
    } catch (error) {
      return null;
    }
  }

  function findConfiguredTarget(root) {
    var customSelector = root.dataset.targetSelector;
    var target = safeQuery(customSelector);

    if (target) return target;

    for (var index = 0; index < FALLBACK_SELECTORS.length; index += 1) {
      target = safeQuery(FALLBACK_SELECTORS[index]);
      if (target) return target;
    }

    return null;
  }

  function getBuybox(target) {
    if (target && target.closest) {
      var closestBuybox = target.closest('.racbu-buybox');
      if (closestBuybox) return closestBuybox;
    }

    return safeQuery('.racbu-buybox');
  }

  function getOfferCard(target) {
    var buybox = getBuybox(target);

    if (buybox) {
      return (
        buybox.querySelector('.racbu-buybox__bundle') ||
        buybox.querySelector('[data-racbu-offer-selector]') ||
        buybox.querySelector('[data-racbu-offer]') ||
        target
      );
    }

    return target;
  }

  function getScrollAnchor(target) {
    var buybox = getBuybox(target);

    if (!buybox) return target;

    /*
      El desplazamiento comienza desde el encabezado superior de la promoción
      para que se aprecien la frase, la tarjeta, el botón y la cantidad.
    */
    return (
      buybox.querySelector('.racbu-buybox__badge-wrap') ||
      buybox.querySelector('.racbu-buybox__bundle') ||
      buybox
    );
  }

  function getFixedHeaderBottom() {
    var selectors = [
      'sticky-header',
      '.header-wrapper',
      '#shopify-section-header',
      '.shopify-section-group-header-group',
      'header'
    ];

    var maximumBottom = 0;

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (element) {
        var style = window.getComputedStyle(element);
        var rect = element.getBoundingClientRect();
        var isFixed = style.position === 'fixed' || style.position === 'sticky';
        var isVisible =
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          rect.height > 0;

        if (
          isFixed &&
          isVisible &&
          rect.top <= 12 &&
          rect.bottom > 0 &&
          rect.bottom < window.innerHeight * 0.45
        ) {
          maximumBottom = Math.max(maximumBottom, rect.bottom);
        }
      });
    });

    return maximumBottom;
  }

  function highlightOffer(target) {
    var offerCard = getOfferCard(target);
    if (!offerCard) return;

    offerCard.classList.remove('racbu-offer-target-highlight');

    window.setTimeout(function () {
      offerCard.classList.add('racbu-offer-target-highlight');
    }, 460);

    window.setTimeout(function () {
      offerCard.classList.remove('racbu-offer-target-highlight');
    }, 2700);
  }

  function focusOffer(target) {
    var offerCard = getOfferCard(target);
    if (!offerCard) return;

    var focusable = offerCard.querySelector(
      'button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href]'
    );

    if (!focusable) {
      offerCard.setAttribute('tabindex', '-1');
      focusable = offerCard;
    }

    window.setTimeout(function () {
      if (focusable && typeof focusable.focus === 'function') {
        focusable.focus({
          preventScroll: true
        });
      }
    }, 820);
  }

  function scrollToOffer(root, status) {
    var configuredTarget = findConfiguredTarget(root);

    if (!configuredTarget) {
      if (status) {
        status.textContent =
          'No se encontró la promoción. Usa .racbu-buybox__bundle como selector de destino.';
      }
      return;
    }

    var scrollAnchor = getScrollAnchor(configuredTarget);

    if (!scrollAnchor) {
      if (status) {
        status.textContent =
          'No se encontró el inicio completo de la promoción.';
      }
      return;
    }

    if (status) status.textContent = '';

    var manualOffset = parseInt(root.dataset.scrollOffset, 10) || 110;
    var dynamicHeaderOffset = getFixedHeaderBottom() + 12;
    var finalOffset = Math.max(manualOffset, dynamicHeaderOffset);
    var anchorTop =
      scrollAnchor.getBoundingClientRect().top +
      window.pageYOffset -
      finalOffset;

    window.scrollTo({
      top: Math.max(0, anchorTop),
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
        ? 'auto'
        : 'smooth'
    });

    highlightOffer(configuredTarget);
    focusOffer(configuredTarget);
  }

  function initOfferSticky(root) {
    if (!root || root.dataset.racbuOfferStickyInit === 'true') return;

    root.dataset.racbuOfferStickyInit = 'true';

    var button = root.querySelector('[data-racbu-offer-button]');
    var status = root.querySelector('[data-racbu-offer-status]');
    var showAfter = parseInt(root.dataset.showAfter, 10) || 180;
    var hideAtTarget = root.dataset.hideAtTarget === 'true';
    var configuredTarget = findConfiguredTarget(root);
    var visibilityTarget = getOfferCard(configuredTarget);
    var targetIsVisible = false;

    function updateVisibility() {
      var shouldShow =
        window.scrollY >= showAfter &&
        !(hideAtTarget && targetIsVisible);

      root.classList.toggle('is-visible', shouldShow);
    }

    if (button) {
      button.addEventListener('click', function () {
        scrollToOffer(root, status);
      });
    }

    if (
      visibilityTarget &&
      hideAtTarget &&
      'IntersectionObserver' in window
    ) {
      var targetObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          /*
            Solo se considera visible cuando una parte relevante de la tarjeta
            completa aparece dentro de la pantalla.
          */
          targetIsVisible =
            entry.isIntersecting &&
            entry.intersectionRatio >= 0.24;

          updateVisibility();
        });
      }, {
        threshold: [0, 0.24, 0.5, 0.75],
        rootMargin: '-90px 0px -105px 0px'
      });

      targetObserver.observe(visibilityTarget);
    }

    window.addEventListener('scroll', updateVisibility, {
      passive: true
    });

    window.addEventListener('resize', updateVisibility);

    updateVisibility();
  }

  function scanOfferSticky(scope) {
    var context = scope || document;

    if (
      context.matches &&
      context.matches('[data-racbu-offer-sticky]')
    ) {
      initOfferSticky(context);
    }

    context
      .querySelectorAll('[data-racbu-offer-sticky]')
      .forEach(initOfferSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanOfferSticky(document);
    });
  } else {
    scanOfferSticky(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scanOfferSticky(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpt_compra"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(number) {
    return number < 10 ? '0' + number : String(number);
  }

  function addDays(date, days, skipWeekends) {
    var result = new Date(date.getTime());
    var added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);

      if (skipWeekends) {
        var weekday = result.getDay();
        if (weekday === 0 || weekday === 6) continue;
      }

      added += 1;
    }

    return result;
  }

  function formatDate(date, locale) {
    try {
      var value = new Intl.DateTimeFormat(locale || 'es-MX', {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      }).format(date);

      return value.charAt(0).toUpperCase() + value.slice(1);
    } catch (error) {
      return date.toLocaleDateString();
    }
  }

  function computeEstimate(root) {
    var cutoffHour = parseInt(root.dataset.cutoffHour, 10) || 13;
    var minDays = parseInt(root.dataset.minDays, 10) || 3;
    var maxDays = parseInt(root.dataset.maxDays, 10) || 7;
    var skipWeekends = root.dataset.skipWeekends === 'true';
    var locale = root.dataset.locale || 'es-MX';

    var now = new Date();
    var cutoff = new Date(now);
    cutoff.setHours(cutoffHour, 0, 0, 0);

    var pastCutoff = now.getTime() >= cutoff.getTime();
    var dispatch = new Date(now);

    if (pastCutoff) {
      dispatch.setDate(dispatch.getDate() + 1);
    }

    return {
      pastCutoff: pastCutoff,
      cutoff: cutoff,
      now: now,
      minDateText: formatDate(addDays(dispatch, minDays, skipWeekends), locale),
      maxDateText: formatDate(addDays(dispatch, maxDays, skipWeekends), locale)
    };
  }

  function setDeliveryContent(element, title, text) {
    if (!element) return;

    element.textContent = '';

    var titleElement = document.createElement('strong');
    var textElement = document.createElement('span');

    titleElement.textContent = title;
    textElement.textContent = text;

    element.appendChild(titleElement);
    element.appendChild(textElement);
  }

  function renderDelivery(root) {
    var cutoffElement = root.querySelector('[data-racbu-cutoff-text]');
    var datesElement = root.querySelector('[data-racbu-dates-text]');

    if (!cutoffElement || !datesElement) return;

    var cutoffHour = parseInt(root.dataset.cutoffHour, 10) || 13;
    var estimate = computeEstimate(root);

    if (!estimate.pastCutoff) {
      var difference = estimate.cutoff.getTime() - estimate.now.getTime();
      var hours = Math.floor(difference / 3600000);
      var minutes = Math.floor((difference % 3600000) / 60000);

      setDeliveryContent(
        cutoffElement,
        'Tu pedido sale hoy',
        'Compra en las próximas ' + hours + ' h ' + pad(minutes) +
          ' min, antes del corte de las ' + pad(cutoffHour) + ':00.'
      );
    } else {
      setDeliveryContent(
        cutoffElement,
        'El corte de hoy ya pasó',
        'Los pedidos realizados después de las ' + pad(cutoffHour) +
          ':00 salen el siguiente día hábil.'
      );
    }

    setDeliveryContent(
      datesElement,
      'Entrega estimada',
      estimate.minDateText + ' – ' + estimate.maxDateText
    );
  }

  function initCountdown(root) {
    renderDelivery(root);

    window.setInterval(function () {
      renderDelivery(root);
    }, 30000);
  }

  function getQuantityElements(root) {
    return {
      input: root.querySelector('[data-racbu-qty-input]'),
      value: root.querySelector('[data-racbu-qty-value]')
    };
  }

  function getQuantity(root) {
    var elements = getQuantityElements(root);
    return elements.input
      ? Math.max(1, parseInt(elements.input.value, 10) || 1)
      : 1;
  }

  function setQuantity(root, value) {
    var elements = getQuantityElements(root);
    var quantity = Math.max(1, parseInt(value, 10) || 1);

    if (elements.input) {
      elements.input.value = quantity;
    }

    if (elements.value) {
      elements.value.textContent = quantity;
      elements.value.setAttribute(
        'aria-label',
        'Cantidad seleccionada: ' + quantity + (quantity === 1 ? ' kit' : ' kits')
      );
    }

    updateBundleState(root);
  }

  function updateBundleState(root) {
    var threshold = parseInt(root.dataset.bundleThreshold, 10) || 3;
    var quantity = getQuantity(root);
    var active = quantity >= threshold;
    var state = root.querySelector('[data-racbu-bundle-state]');
    var helper = root.querySelector('[data-racbu-bundle-helper]');
    var buttonLabel = root.querySelector('[data-racbu-label]');
    var quickOffer = root.querySelector('[data-racbu-select-bundle]');
    var defaultButtonText = root.dataset.defaultButtonText || 'QUIERO MI RITUAL';
    var activeButtonText =
      root.dataset.activeButtonText || 'ACTIVAR 15% OFF + RODILLO GRATIS';

    root.classList.toggle('is-bundle-active', active);

    if (state) {
      if (active) {
        state.textContent = 'OFERTA ACTIVADA · 15% OFF + RODILLO GRATIS';
      } else {
        var remaining = threshold - quantity;
        state.textContent = remaining === 1
          ? 'Agrega 1 kit más para activar la oferta'
          : 'Agrega ' + remaining + ' kits más para activar la oferta';
      }
    }

    if (helper) {
      helper.textContent = active
        ? 'Tus ' + quantity + ' kits cubren aproximadamente ' +
          (quantity * 30) + ' a ' + (quantity * 45) +
          ' días de rutina e incluyen 1 Rodillo de Titanio.'
        : 'Cada kit dura entre 30 y 45 días.';
    }

    if (
      buttonLabel &&
      !root.classList.contains('is-loading') &&
      !root.classList.contains('is-success')
    ) {
      buttonLabel.textContent = active
        ? activeButtonText
        : defaultButtonText;
    }

    if (quickOffer) {
      quickOffer.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function initQuantity(root) {
    var wrapper = root.querySelector('[data-racbu-qty]');
    if (!wrapper) return;

    var minus = wrapper.querySelector('[data-racbu-qty-minus]');
    var plus = wrapper.querySelector('[data-racbu-qty-plus]');
    var quickOffer = root.querySelector('[data-racbu-select-bundle]');
    var threshold = parseInt(root.dataset.bundleThreshold, 10) || 3;

    if (minus) {
      minus.addEventListener('click', function () {
        setQuantity(root, getQuantity(root) - 1);
      });
    }

    if (plus) {
      plus.addEventListener('click', function () {
        setQuantity(root, getQuantity(root) + 1);
      });
    }

    if (quickOffer) {
      quickOffer.addEventListener('click', function () {
        setQuantity(root, threshold);

        window.setTimeout(function () {
          var submitButton = root.querySelector('[data-racbu-submit]');
          if (submitButton) submitButton.focus({ preventScroll: true });
        }, 120);
      });
    }

    setQuantity(root, getQuantity(root));
  }

  function setState(root, state) {
    root.classList.remove('is-loading', 'is-success');

    if (state) {
      root.classList.add(state);
    }
  }

  function getCurrentVariantId(root, formData) {
    var variantId = parseInt(formData.get('id'), 10);

    try {
      var urlVariant = parseInt(
        new URL(window.location.href).searchParams.get('variant'),
        10
      );

      if (Number.isFinite(urlVariant)) {
        variantId = urlVariant;
      }
    } catch (error) {
      /* La URL actual no necesita corrección. */
    }

    return variantId;
  }

  function getErrorMessage(data) {
    if (!data) return 'No se pudo agregar el producto.';

    return (
      data.description ||
      data.message ||
      data.error ||
      'No se pudo agregar el producto.'
    );
  }

  function initForm(root) {
    var form = root.querySelector('[data-racbu-form]');
    if (!form) return;

    var status = root.querySelector('[data-racbu-status]');
    var addUrl = root.dataset.cartAddUrl || '/cart/add.js';
    var redirectToCart = root.dataset.redirectCart === 'true';
    var cartUrl = root.dataset.cartUrl || '/cart';
    var threshold = parseInt(root.dataset.bundleThreshold, 10) || 3;
    var giftVariantId = parseInt(root.dataset.giftVariantId, 10);
    var giftAvailable = root.dataset.giftAvailable === 'true';
    var discountMode = root.dataset.discountMode || 'automatic';
    var discountCode = (root.dataset.bundleDiscountCode || '').trim();

    document.addEventListener('variant:change', function (event) {
      var variantInput = root.querySelector('[data-racbu-variant-id]');

      if (
        variantInput &&
        event.detail &&
        event.detail.variant &&
        event.detail.variant.id
      ) {
        variantInput.value = event.detail.variant.id;
      }
    });

    document.addEventListener('change', function (event) {
      var changedInput = event.target;

      if (
        !changedInput ||
        !changedInput.matches ||
        !changedInput.matches('input[name="id"], select[name="id"]') ||
        root.contains(changedInput)
      ) {
        return;
      }

      var variantInput = root.querySelector('[data-racbu-variant-id]');
      var selectedVariantId = parseInt(changedInput.value, 10);

      if (variantInput && Number.isFinite(selectedVariantId)) {
        variantInput.value = selectedVariantId;
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (root.classList.contains('is-loading')) return;

      var formData = new FormData(form);
      var quantity = getQuantity(root);
      var mainVariantId = getCurrentVariantId(root, formData);
      var bundleActive = quantity >= threshold;

      status.textContent = '';
      status.classList.remove('is-error');

      if (!Number.isFinite(mainVariantId)) {
        status.textContent =
          'No se encontró una variante válida del producto.';
        status.classList.add('is-error');
        return;
      }

      /*
        Esta era la principal causa del bloqueo:
        al activar la oferta el código exige un regalo válido.
        El selector de producto evita depender de un ID escrito manualmente.
      */
      if (
        bundleActive &&
        (!Number.isFinite(giftVariantId) || giftVariantId <= 0)
      ) {
        status.textContent =
          'Configura el producto Rodillo de Titanio en “Oferta de 3 kits” antes de activar la promoción.';
        status.classList.add('is-error');
        return;
      }

      if (
        bundleActive &&
        root.dataset.giftAvailable !== '' &&
        !giftAvailable
      ) {
        status.textContent =
          'El Rodillo de Titanio seleccionado no está disponible. Revisa su inventario o variante.';
        status.classList.add('is-error');
        return;
      }

      if (bundleActive && giftVariantId === mainVariantId) {
        status.textContent =
          'El producto del regalo no puede ser el mismo kit que se está comprando.';
        status.classList.add('is-error');
        return;
      }

      if (
        bundleActive &&
        discountMode === 'code' &&
        !discountCode
      ) {
        status.textContent =
          'Falta configurar el código de descuento del 15% en el editor del tema.';
        status.classList.add('is-error');
        return;
      }

      var items = [
        {
          id: mainVariantId,
          quantity: quantity,
          properties: bundleActive
            ? {
                '_Oferta RACBU': '15% OFF al llevar 3 o más kits',
                '_Duración estimada': '30 a 45 días por kit'
              }
            : {}
        }
      ];

      if (bundleActive) {
        items.push({
          id: giftVariantId,
          quantity: 1,
          properties: {
            '_Regalo': 'Rodillo de Titanio Gratis',
            '_Promoción': 'Compra de 3 o más kits'
          }
        });
      }

      setState(root, 'is-loading');

      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return {
              ok: response.ok,
              data: data
            };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            throw new Error(getErrorMessage(result.data));
          }

          setState(root, 'is-success');
          status.textContent = bundleActive
            ? quantity + ' kits y el rodillo gratis fueron agregados al carrito.'
            : quantity + (quantity === 1 ? ' kit fue agregado al carrito.' : ' kits fueron agregados al carrito.');

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              detail: result.data
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: result.data
            })
          );

          window.setTimeout(function () {
            if (!redirectToCart) {
              setState(root, null);
              updateBundleState(root);
              return;
            }

            if (bundleActive && discountMode === 'code') {
              window.location.href =
                '/discount/' + encodeURIComponent(discountCode) +
                '?redirect=' + encodeURIComponent(cartUrl);
            } else {
              window.location.href = cartUrl;
            }
          }, 850);
        })
        .catch(function (error) {
          setState(root, null);
          updateBundleState(root);
          status.textContent =
            error.message ||
            'No se pudo agregar el producto. Revisa el inventario e intenta de nuevo.';
          status.classList.add('is-error');
        });
    });
  }

  function initReveal(root) {
    var elements = root.querySelectorAll('[data-racbu-reveal]');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -6% 0px'
    });

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function initBuybox(root) {
    if (!root || root.dataset.racbuInit === 'true') return;

    root.dataset.racbuInit = 'true';

    initQuantity(root);
    initForm(root);
    initReveal(root);
    initCountdown(root);
    updateBundleState(root);
  }

  function scanBuyboxes(scope) {
    var context = scope || document;

    if (
      context.matches &&
      context.matches('[data-racbu-buybox]')
    ) {
      initBuybox(context);
    }

    context
      .querySelectorAll('[data-racbu-buybox]')
      .forEach(initBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanBuyboxes(document);
    });
  } else {
    scanBuyboxes(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scanBuyboxes(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpt_ingredientes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function setActiveIngredient(root, index) {
    var cards = root.querySelectorAll('[data-racbu-ing-card]');
    var dots = root.querySelectorAll('[data-racbu-ing-dot]');
    var activeName = root.querySelector('[data-racbu-ing-active-name]');
    var total = cards.length;

    if (!total) return;

    var safeIndex = Math.max(0, Math.min(index, total - 1));
    var selectedCard = cards[safeIndex];

    cards.forEach(function (card, cardIndex) {
      card.classList.toggle('is-active', cardIndex === safeIndex);
    });

    dots.forEach(function (dot, dotIndex) {
      dot.classList.toggle('is-active', dotIndex === safeIndex);
    });

    if (activeName && selectedCard) {
      activeName.textContent = selectedCard.dataset.racbuIngName || '';
    }

    var progress = total === 1 ? 100 : ((safeIndex + 1) / total) * 100;
    root.style.setProperty('--racbu-ing-progress', progress + '%');
  }

  function initReveal(root) {
    var items = root.querySelectorAll('[data-racbu-ing-reveal]');

    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -7% 0px'
    });

    items.forEach(function (item) {
      revealObserver.observe(item);
    });
  }

  function initIngredientTracking(root) {
    var cards = root.querySelectorAll('[data-racbu-ing-card]');

    if (!cards.length) return;

    setActiveIngredient(root, 0);

    if (!('IntersectionObserver' in window)) return;

    var activeObserver = new IntersectionObserver(function (entries) {
      var visibleEntries = entries
        .filter(function (entry) {
          return entry.isIntersecting;
        })
        .sort(function (a, b) {
          return b.intersectionRatio - a.intersectionRatio;
        });

      if (!visibleEntries.length) return;

      var index = parseInt(visibleEntries[0].target.dataset.racbuIngIndex, 10);
      if (Number.isFinite(index)) setActiveIngredient(root, index);
    }, {
      threshold: [0.28, 0.48, 0.68],
      rootMargin: '-18% 0px -34% 0px'
    });

    cards.forEach(function (card) {
      activeObserver.observe(card);
    });
  }

  function initParallax(root) {
    var product = root.querySelector('[data-racbu-ing-product]');

    if (!product || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var ticking = false;

    function update() {
      var rect = root.getBoundingClientRect();
      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var progress = (viewport - rect.top) / (viewport + rect.height);
      var clamped = Math.max(0, Math.min(1, progress));
      var offset = (clamped - 0.5) * 18;

      root.style.setProperty('--racbu-product-y', offset.toFixed(2) + 'px');
      ticking = false;
    }

    function requestUpdate() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  }

  function initRacbuIngredients(root) {
    if (!root || root.dataset.racbuIngredientsInit === 'true') return;

    root.dataset.racbuIngredientsInit = 'true';
    initReveal(root);
    initIngredientTracking(root);
    initParallax(root);
  }

  function scanRacbuIngredients(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-racbu-ingredients]')) {
      initRacbuIngredients(context);
    }

    context.querySelectorAll('[data-racbu-ingredients]').forEach(initRacbuIngredients);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanRacbuIngredients(document);
    });
  } else {
    scanRacbuIngredients(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scanRacbuIngredients(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target.closest('[data-racbu-ing-card]');
    var root = event.target.closest('[data-racbu-ingredients]');

    if (!card || !root) return;

    var index = parseInt(card.dataset.racbuIngIndex, 10);
    if (Number.isFinite(index)) setActiveIngredient(root, index);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpt_ofertas_kit"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(number) {
    return number < 10 ? '0' + number : String(number);
  }

  function addDays(date, days, skipWeekends) {
    var result = new Date(date.getTime());
    var added = 0;

    while (added < days) {
      result.setDate(result.getDate() + 1);

      if (skipWeekends) {
        var weekday = result.getDay();
        if (weekday === 0 || weekday === 6) continue;
      }

      added += 1;
    }

    return result;
  }

  function formatDate(date, locale) {
    try {
      var value = new Intl.DateTimeFormat(locale || 'es-MX', {
        weekday: 'short',
        day: 'numeric',
        month: 'short'
      }).format(date);

      return value.charAt(0).toUpperCase() + value.slice(1);
    } catch (error) {
      return date.toLocaleDateString();
    }
  }

  function setDeliveryContent(element, title, text) {
    if (!element) return;

    element.textContent = '';

    var titleElement = document.createElement('strong');
    var textElement = document.createElement('span');

    titleElement.textContent = title;
    textElement.textContent = text;

    element.appendChild(titleElement);
    element.appendChild(textElement);
  }

  function renderDelivery(root) {
    var cutoffElement = root.querySelector('[data-racbu-cutoff-text]');
    var datesElement = root.querySelector('[data-racbu-dates-text]');

    if (!cutoffElement || !datesElement) return;

    var cutoffHour = parseInt(root.dataset.cutoffHour, 10) || 13;
    var minDays = parseInt(root.dataset.minDays, 10) || 3;
    var maxDays = parseInt(root.dataset.maxDays, 10) || 7;
    var skipWeekends = root.dataset.skipWeekends === 'true';
    var locale = root.dataset.locale || 'es-MX';
    var now = new Date();
    var cutoff = new Date(now);

    cutoff.setHours(cutoffHour, 0, 0, 0);

    var pastCutoff = now.getTime() >= cutoff.getTime();
    var dispatch = new Date(now);

    if (pastCutoff) {
      dispatch.setDate(dispatch.getDate() + 1);
    }

    if (!pastCutoff) {
      var difference = cutoff.getTime() - now.getTime();
      var hours = Math.floor(difference / 3600000);
      var minutes = Math.floor((difference % 3600000) / 60000);

      setDeliveryContent(
        cutoffElement,
        'Tu pedido sale hoy',
        'Compra en las próximas ' + hours + ' h ' + pad(minutes) +
          ' min, antes del corte de las ' + pad(cutoffHour) + ':00.'
      );
    } else {
      setDeliveryContent(
        cutoffElement,
        'El corte de hoy ya pasó',
        'Los pedidos realizados después de las ' + pad(cutoffHour) +
          ':00 salen el siguiente día hábil.'
      );
    }

    setDeliveryContent(
      datesElement,
      'Entrega estimada',
      formatDate(addDays(dispatch, minDays, skipWeekends), locale) +
        ' – ' +
        formatDate(addDays(dispatch, maxDays, skipWeekends), locale)
    );
  }

  function getQuantity(root) {
    var input = root.querySelector('[data-racbu-qty-input]');
    return input ? Math.max(1, Math.min(3, parseInt(input.value, 10) || 1)) : 1;
  }

  function getPlanMessage(root, quantity) {
    var twoDiscount = parseInt(root.dataset.twoDiscount, 10) || 5;
    var threeDiscount = parseInt(root.dataset.threeDiscount, 10) || 15;
    var onePrice = root.dataset.onePrice || '';
    var twoPrice = root.dataset.twoPrice || '';
    var threePrice = root.dataset.threePrice || '';

    if (quantity === 2) {
      return 'Oferta seleccionada: 2 kits · ' + twoDiscount +
        '% OFF · ' + twoPrice + ' · aproximadamente 60 a 90 días de rutina.';
    }

    if (quantity === 3) {
      return 'Oferta premium seleccionada: 3 kits · ' + threeDiscount +
        '% OFF + Rodillo de Titanio gratis · ' + threePrice + ' · aproximadamente 90 a 135 días.';
    }

    return 'Opción seleccionada: 1 kit · ' + onePrice + ' · aproximadamente 30 a 45 días de rutina.';
  }

  function updateSelection(root, quantity) {
    var input = root.querySelector('[data-racbu-qty-input]');
    var summary = root.querySelector('[data-racbu-plan-summary] p');
    var buttonLabel = root.querySelector('[data-racbu-label]');
    var buttonOne = root.dataset.buttonOne || 'COMPRAR 1 KIT';
    var buttonTwo = root.dataset.buttonTwo || 'COMPRAR 2 KITS CON 5% OFF';
    var buttonThree = root.dataset.buttonThree || 'ACTIVAR 15% OFF + RODILLO GRATIS';

    quantity = Math.max(1, Math.min(3, parseInt(quantity, 10) || 1));

    if (input) input.value = quantity;

    root.querySelectorAll('[data-racbu-plan]').forEach(function (plan) {
      var selected = parseInt(plan.dataset.quantity, 10) === quantity;
      plan.classList.toggle('is-active', selected);
      plan.setAttribute('aria-checked', selected ? 'true' : 'false');
    });

    root.classList.remove('is-plan-one', 'is-plan-two', 'is-plan-three');
    root.classList.add(
      quantity === 3
        ? 'is-plan-three'
        : quantity === 2
          ? 'is-plan-two'
          : 'is-plan-one'
    );

    if (summary) {
      summary.textContent = getPlanMessage(root, quantity);
    }

    if (
      buttonLabel &&
      !root.classList.contains('is-loading') &&
      !root.classList.contains('is-success')
    ) {
      buttonLabel.textContent =
        quantity === 3
          ? buttonThree
          : quantity === 2
            ? buttonTwo
            : buttonOne;
    }
  }

  function initPlans(root) {
    root.querySelectorAll('[data-racbu-plan]').forEach(function (plan) {
      plan.addEventListener('click', function () {
        updateSelection(root, plan.dataset.quantity);
      });
    });

    updateSelection(root, getQuantity(root));
  }

  function setState(root, state) {
    root.classList.remove('is-loading', 'is-success');
    if (state) root.classList.add(state);
  }

  function getCurrentVariantId(root, formData) {
    var variantId = parseInt(formData.get('id'), 10);

    try {
      var urlVariant = parseInt(
        new URL(window.location.href).searchParams.get('variant'),
        10
      );

      if (Number.isFinite(urlVariant)) {
        variantId = urlVariant;
      }
    } catch (error) {
      /* No se requiere corrección de URL. */
    }

    return variantId;
  }

  function getErrorMessage(data) {
    if (!data) return 'No se pudo agregar el producto.';

    return (
      data.description ||
      data.message ||
      data.error ||
      'No se pudo agregar el producto.'
    );
  }

  function initForm(root) {
    var form = root.querySelector('[data-racbu-form]');
    if (!form) return;

    var status = root.querySelector('[data-racbu-status]');
    var addUrl = root.dataset.cartAddUrl || '/cart/add.js';
    var cartUrl = root.dataset.cartUrl || '/cart';
    var redirectToCart = root.dataset.redirectCart === 'true';
    var giftVariantId = parseInt(root.dataset.giftVariantId, 10);
    var giftAvailable = root.dataset.giftAvailable === 'true';
    var discountMode = root.dataset.discountMode || 'automatic';
    var twoDiscountCode = (root.dataset.twoDiscountCode || '').trim();
    var threeDiscountCode = (root.dataset.threeDiscountCode || '').trim();

    document.addEventListener('variant:change', function (event) {
      var variantInput = root.querySelector('[data-racbu-variant-id]');

      if (
        variantInput &&
        event.detail &&
        event.detail.variant &&
        event.detail.variant.id
      ) {
        variantInput.value = event.detail.variant.id;
      }
    });

    document.addEventListener('change', function (event) {
      var changedInput = event.target;

      if (
        !changedInput ||
        !changedInput.matches ||
        !changedInput.matches('input[name="id"], select[name="id"]') ||
        root.contains(changedInput)
      ) {
        return;
      }

      var variantInput = root.querySelector('[data-racbu-variant-id]');
      var selectedVariantId = parseInt(changedInput.value, 10);

      if (variantInput && Number.isFinite(selectedVariantId)) {
        variantInput.value = selectedVariantId;
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (root.classList.contains('is-loading')) return;

      var formData = new FormData(form);
      var quantity = getQuantity(root);
      var mainVariantId = getCurrentVariantId(root, formData);
      var isTwoKitOffer = quantity === 2;
      var isThreeKitOffer = quantity === 3;
      var appliedCode = '';

      status.textContent = '';
      status.classList.remove('is-error');

      if (!Number.isFinite(mainVariantId)) {
        status.textContent = 'No se encontró una variante válida del producto.';
        status.classList.add('is-error');
        return;
      }

      if (
        isThreeKitOffer &&
        (!Number.isFinite(giftVariantId) || giftVariantId <= 0)
      ) {
        status.textContent =
          'Configura el Producto del Rodillo de Titanio antes de activar la oferta de 3 kits.';
        status.classList.add('is-error');
        return;
      }

      if (
        isThreeKitOffer &&
        root.dataset.giftAvailable !== '' &&
        !giftAvailable
      ) {
        status.textContent =
          'El Rodillo de Titanio no está disponible. Revisa su inventario.';
        status.classList.add('is-error');
        return;
      }

      if (isThreeKitOffer && giftVariantId === mainVariantId) {
        status.textContent =
          'El regalo no puede ser el mismo producto que el kit.';
        status.classList.add('is-error');
        return;
      }

      if (discountMode === 'code') {
        if (isTwoKitOffer) appliedCode = twoDiscountCode;
        if (isThreeKitOffer) appliedCode = threeDiscountCode;

        if ((isTwoKitOffer || isThreeKitOffer) && !appliedCode) {
          status.textContent =
            isThreeKitOffer
              ? 'Falta configurar el código de descuento del 15%.'
              : 'Falta configurar el código de descuento del 5%.';
          status.classList.add('is-error');
          return;
        }
      }

      var properties = {
        '_Cantidad seleccionada': quantity + (quantity === 1 ? ' kit' : ' kits'),
        '_Duración estimada': (quantity * 30) + ' a ' + (quantity * 45) + ' días'
      };

      if (isTwoKitOffer) {
        properties['_Oferta RACBU'] =
          (parseInt(root.dataset.twoDiscount, 10) || 5) + '% OFF al llevar 2 kits';
      }

      if (isThreeKitOffer) {
        properties['_Oferta RACBU'] =
          (parseInt(root.dataset.threeDiscount, 10) || 15) +
          '% OFF + Rodillo de Titanio gratis';
      }

      var items = [{
        id: mainVariantId,
        quantity: quantity,
        properties: properties
      }];

      if (isThreeKitOffer) {
        items.push({
          id: giftVariantId,
          quantity: 1,
          properties: {
            '_Regalo': 'Rodillo de Titanio Gratis',
            '_Promoción': 'Oferta de 3 kits'
          }
        });
      }

      setState(root, 'is-loading');

      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            throw new Error(getErrorMessage(result.data));
          }

          setState(root, 'is-success');

          if (isThreeKitOffer) {
            status.textContent =
              '3 kits y el Rodillo de Titanio fueron agregados al carrito.';
          } else if (isTwoKitOffer) {
            status.textContent =
              '2 kits con la oferta del 5% fueron agregados al carrito.';
          } else {
            status.textContent = '1 kit fue agregado al carrito.';
          }

          document.dispatchEvent(
            new CustomEvent('cart:refresh', { detail: result.data })
          );

          document.dispatchEvent(
            new CustomEvent('cart:updated', { detail: result.data })
          );

          window.setTimeout(function () {
            if (!redirectToCart) {
              setState(root, null);
              updateSelection(root, quantity);
              return;
            }

            if (discountMode === 'code' && appliedCode) {
              window.location.href =
                '/discount/' + encodeURIComponent(appliedCode) +
                '?redirect=' + encodeURIComponent(cartUrl);
            } else {
              window.location.href = cartUrl;
            }
          }, 850);
        })
        .catch(function (error) {
          setState(root, null);
          updateSelection(root, quantity);
          status.textContent =
            error.message ||
            'No se pudo agregar el producto. Revisa el inventario e intenta de nuevo.';
          status.classList.add('is-error');
        });
    });
  }

  function initReveal(root) {
    var elements = root.querySelectorAll('[data-racbu-reveal]');

    if (!('IntersectionObserver' in window)) {
      elements.forEach(function (element) {
        element.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -6% 0px'
    });

    elements.forEach(function (element) {
      observer.observe(element);
    });
  }

  function initBuybox(root) {
    if (!root || root.dataset.racbuInit === 'true') return;

    root.dataset.racbuInit = 'true';

    initPlans(root);
    initForm(root);
    initReveal(root);
    renderDelivery(root);

    window.setInterval(function () {
      renderDelivery(root);
    }, 30000);
  }

  function scanBuyboxes(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-racbu-buybox]')) {
      initBuybox(context);
    }

    context.querySelectorAll('[data-racbu-buybox]').forEach(initBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanBuyboxes(document);
    });
  } else {
    scanBuyboxes(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scanBuyboxes(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gpt_rutina"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRacbuRitual(root) {
    if (!root || root.dataset.racbuRitualInit === 'true') return;

    root.dataset.racbuRitualInit = 'true';

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      root.classList.add('is-active');
      return;
    }

    root.classList.add('is-motion-ready');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        root.classList.add('is-active');
        observer.unobserve(root);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -8% 0px'
    });

    observer.observe(root);
  }

  function scanRacbuRituals(scope) {
    var context = scope || document;

    if (context.matches && context.matches('[data-racbu-ritual]')) {
      initRacbuRitual(context);
    }

    context.querySelectorAll('[data-racbu-ritual]').forEach(initRacbuRitual);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanRacbuRituals(document);
    });
  } else {
    scanRacbuRituals(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scanRacbuRituals(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
